<div class="image_container">
  <div class="img-sub-container">
    <div class="image_outer" [ngStyle]="{'background-image': 'url('+ chapterDetails.chapterBanner + ')'}">
      <div class="img_opacity"></div>
    </div>
    <div *ngIf="successMsgShow" class="chapter_home_alert">
      <app-alert-modal></app-alert-modal>
    </div>
    <div class="alert alert-danger" *ngIf="timeOutError">
      {{timeoutErrorMessage}}
    </div>

    <div class="image_text">
      <span id="imageText_size_header" *ngIf="chapterDetails">{{chapterDetails.bpgName}}</span><br>
      <span id="imageText_size" *ngIf="chapterDetails" [innerHtml]="chapterDetails.bpgDesc"></span><br>
    </div>
  </div>
</div>

<!--chapter leadership-->
<div class="container-fluid"
  *ngIf="(chapterLeadershipDetails!=null && chapterLeadershipDetails!='' && chapterLeadershipDetails!=undefined) || (chapterExecutiveSponsorDetails!=null && chapterExecutiveSponsorDetails!=undefined || chapterBoardList.length>0)">
  <div class="row">
    <h3 class="col-md-12" id="leadershipTeam">Leadership Team</h3>
    <div class="reteam engagement_div"
      *ngIf="chapterExecutiveSponsorDetails!=null && chapterExecutiveSponsorDetails!=undefined">
      <div>
        <img src={{chapterExecutiveSponsorDetails.userPic}} alt="" class="picture"
          *ngIf="chapterExecutiveSponsorDetails.userPic!='' && chapterExecutiveSponsorDetails.userPic!=null">
        <img src='assets/images/placeholder.jpg' alt="" class="picture"
          *ngIf="chapterExecutiveSponsorDetails.userPic=='' || chapterExecutiveSponsorDetails.userPic==null">
      </div>
      <div class="userdetails">
        <div class="username">{{chapterExecutiveSponsorDetails.executiveSponsorName}} </div>
        <div class="rolename" style="font-family: 'Montserrat-Regular',sans-serif;">EXECUTIVE SPONSOR</div>
        <div class="rolename"><span class="fa fa-envelope" style="color:#b62027 ;">
            <a class="email"
              href="mailto:{{chapterExecutiveSponsorDetails.executiveSponsorEmailId}}">{{chapterExecutiveSponsorDetails.executiveSponsorEmailId}}</a></span>
        </div>


        <div class="rolename"
          *ngIf="(chapterExecutiveSponsorDetails.executiveSponsorPronounce != null && chapterExecutiveSponsorDetails.executiveSponsorPronounce != '' && chapterExecutiveSponsorDetails.executiveSponsorPronounce != undefined)">
          <span class="siteLabel">Pronouns :</span>
          <span class="siteValue">{{chapterExecutiveSponsorDetails.executiveSponsorPronounce}}</span>
        </div>
      </div>
    </div>
    <div class="reteam engagement_div" *ngFor="let reTeaminfo of chapterLeadershipDetails">
      <div>
        <img src={{reTeaminfo.userPic}} alt="" class="picture"
          *ngIf="reTeaminfo.userPic!='' && reTeaminfo.userPic!=null">
        <img src='assets/images/placeholder.jpg' alt="" class="picture"
          *ngIf="reTeaminfo.userPic=='' || reTeaminfo.userPic==null">
      </div>
      <div class="userdetails">
        <div class="username">{{reTeaminfo.userName}} </div>
        <div class="rolename" style="font-family: 'Montserrat-Regular',sans-serif;">{{reTeaminfo.positionName}}</div>
        <div class="rolename"><span class="fa fa-envelope" style="color:#b62027 ;">
            <a class="email" href="mailto:{{reTeaminfo.emailId}}">{{reTeaminfo.emailAddress}}</a></span></div>


        <div class="rolename"
          *ngIf="(reTeaminfo.leadershipPronounce!= null && reTeaminfo.leadershipPronounce!= '' && reTeaminfo.leadershipPronounce!= undefined)">
          <span class="siteLabel">Pronouns :</span>
          <span class="siteValue">{{reTeaminfo.leadershipPronounce}}</span>
        </div>
      </div>
    </div>
    <div class="reteam engagement_div" *ngFor="let member of chapterBoardList">
      <div>
        <img src={{member.userPic}} alt="" class="picture" *ngIf="member.userPic!='' && member.userPic!=null">
        <img src='assets/images/placeholder.jpg' alt="" class="picture"
          *ngIf="member.userPic=='' || member.userPic==null">
      </div>
      <div class="userdetails">
        <div class="username">{{member.userName}} </div>
        <div class="rolename" style="font-family: 'Montserrat-Regular',sans-serif;">{{member.designation}}</div>
        <div class="rolename"><span class="fa fa-envelope" style="color:#b62027 ;">
            <a class="email" href="mailto:{{member.emailId}}">{{member.emailId}}</a></span></div>


        <div class="rolename" *ngIf="(member.pronoun!= null && member.pronoun!= '' && member.pronoun!= undefined)">
          <span class="siteLabel">Pronouns :</span>
          <span class="siteValue">{{member.pronoun}}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="contact-div" *ngIf="this.chapterDetails.chapterEmail">
    <button type="button" (click)="contactUs()" class="contact1">CONTACT US</button>
  </div>
  <div class="paragraph-div" style="display: none">
    <p class="membership-para">{{withdrawMembershipPara}}</p>
    <div class="btn-becomeamember-div">
      <button type="button" class="btn btn-becomeamember"><a class="a_becomeamember" (click)="withdrawMembership()">
          WITHDRAW MEMBERSHIP</a></button>
    </div>
  </div>
</div>
<!--vision, mission,chapter gallery and feedback-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 gallery-padding">
      <div>
        <!-- carousel code-->
        <ngb-carousel (slide)="onSlide($event)"
          *ngIf="(galleryItemsList != null && galleryItemsList != undefined) && galleryItemsList.length > 0 ">
          <ng-template ngbSlide *ngFor=" let data of galleryItemsList,let i=index;">
            <div class="picsum-img-wrapper">
              <img class="slide-image"
                *ngIf="(data.fileName.toLowerCase().indexOf('.jpg') !== -1) || (data.fileName.toLowerCase().indexOf('.png') !== -1) || (data.fileName.toLowerCase().indexOf('.jpeg') !== -1)"
                src='{{data.fileName}}' alt="Random first slide">
              <video class="slide-image" *ngIf="(data.fileName.toLowerCase().indexOf('.ogg') !== -1)" width="800"
                controls>
                <source src="{{data.fileName}}" type="video/ogg">
              </video>
              <video class="slide-image"
                *ngIf="(data.fileName.toLowerCase().indexOf('.mp4') !== -1) || (data.fileName.toLowerCase().indexOf('.mov') !== -1)"
                width="800" controls>
                <source src="{{data.fileName}}" type="video/mp4">
              </video>


            </div>


            <div class="carousel-caption">
              <div class="reponsive-padding"><a downloadAttachments-btn id='downloadFiles{{i}}'
                  (click)="downloadAttachments(data,i,'downloadFiles')"><img class="download-img"
                    src="assets/images/download-button.png" alt="Angular Logo"></a></div>
            </div>
          </ng-template>

        </ngb-carousel>
      
      </div>

    </div>
    <div class="col-md-6"
      style="background-color: #f4f4f4 !important;height:380px;overflow: auto;">
      <div>
        <h3 class="feedback text-center">CHAPTER FEEDBACK <button
            *ngIf="chapterFeedbackList.length>0 && !addChapterFeedback" type="button" class="btn btn-danger mb-2"
            (click)="addchapterFeedback()">ADD</button></h3>
        <div *ngIf="chapterFeedbackList.length == 0 || addChapterFeedback">
          <textarea style="background-color:white !important" class="form-control mt-2" id="chapterFeedback"
            name="chapterFeedback" [(ngModel)]="chapterFeedback" maxlength="2000"
            placeholder="Give your feedback here.." rows="8" autocomplete="off"></textarea>
          <div class="mt-3">
            <button type="button" class="btn btn-danger" (click)="sendChapterFeedback()"
              [disabled]="(chapterFeedback==null || chapterFeedback == '')">SUBMIT</button>
            <button type="button" class="btn btn-danger " style="margin-left:2%"
              (click)="cancelChapterFeedback()">CANCEL</button>
            <span class="alert alert-success" style="margin-left: 2%" (click)="sendFeedback" *ngIf="sendFeedback">
              Feedback sent to Admin!
            </span>
            <span class="alert alert-danger" style="margin-left: 2%" *ngIf="sendFeedbackFailure">
              {{errorMsg}}
            </span>
          </div>


        </div>
        <div *ngIf="chapterFeedbackList.length>0 && !addChapterFeedback">

          <div *ngFor="let feedback of chapterFeedbackList">
            <div class="mb-2" style="background-color:white">
              <div style="margin-left:5px"> {{feedback.chapterFeedback}} </div>
              <div style="font-weight: bold;text-align: end;margin-right:5px"> Added On {{feedback.createdDateTime |
                date: 'MM-dd-yyyy'}} </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- ADDITIONAL BPG RESOURCES & NAAC SECTION -->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 additional_bpg_outerdiv" [ngClass]="{'hideDesc_2': flag2}">

      <h3 class="additional_heading">CHAPTER RESOURCES</h3>
      <div *ngIf="noFolderFound" class="noFolderFound">
        No Resource Found!
      </div>
      <div *ngIf="!noFolderFound">
        <div *ngFor="let resourceInfo of chapterFolderList,let i=index;">
          <div class="resourceTitle"><a class="resorce_underline"
              (click)="selectdiFolder(resourceInfo.folderId,resourceInfo.folderName)">{{resourceInfo.Maxmin}} </a>{{resourceInfo.folderName}}
          </div>
          <span *ngIf="resourceInfo.showFolder">
            <span *ngFor="let file of fileList,let j=index;">
                           <div class="filename"><a class="files" (click)="downloadAttachments(file,j,'resFile')"
                  downloadAttachments-btn id='resFile{{j}}'>{{file.documentName}}</a>
               <div *ngIf="(file.originalFileName.toLowerCase().indexOf('.mp3') !== -1)" style="display:flex">
                <div>
                <audio controls  class="mt-2" style="height:30px">
                 <source src="{{file.fileName}}" type="audio/mpeg">
                
                </audio>
                </div>
                <div style="margin-left:5%;margin-top: 2%;font-size: 14px;" *ngIf="(file.originalFileName.toLowerCase().indexOf('.mp3') !== -1) && file.downloadsCount">{{file.downloadsCount}} Downloads</div>

                  </div>
     </div>
            </span> </span>

        </div>
      </div>
    </div>
    <div class="col-md-6 full_description_outerdiv bpg_news_outerdiv">
      <span class="news_heading">LATEST ANNOUNCEMENTS</span>
      <div *ngIf="noAnnouncementFound" class="noFolderFound" style="margin-top: 25px;">
        No Announcements Found!
      </div>
      <div *ngIf="!noAnnouncementFound">

        <div class="news-scroller-header">
          <div class="news-scroll" id="newsId">
            <div *ngFor="let newsInfo of announcementList">
              <div>
                <img src="{{newsInfo.presignedUrl}}" class="news_image" alt="Angular Logo">

              </div>
              <div class="title_main_div side-left ">
                <div class="news_title ">{{newsInfo.announcementTitle}}</div>
                <div class="news_create_time">{{newsInfo.modifiedDateTime | date:'MM-dd-yyyy'}}</div>
              </div>

              <div class="news_description_div side-left">

                <p class="news_description" *ngIf="newsInfo.showFullWord">{{newsInfo.announcementDescription}} </p>
                <p class="news_description" *ngIf="!newsInfo.showFullWord">{{newsInfo.minWord}} </p>
                <span class="viewmore" (click)=showFullDesc(newsInfo.chaptersAnnouncementId)
                  *ngIf="!newsInfo.showFullWord"> View More</span>
                <span
                  *ngIf="(newsInfo.announcementDescription==null || newsInfo.announcementDescription==undefined || newsInfo.announcementDescription=='')">
                  &nbsp;</span>
              </div>
              <div
                *ngIf="(newsInfo.externalLinks== '' || newsInfo.externalLinks==undefined || newsInfo.externalLinks== null)">
                &nbsp;</div>
              <div class="news_link_div side-left"
                *ngIf="newsInfo.externalLinks!= null && newsInfo.externalLinks.substring(0,4) =='http'">
                <a class="news_link" href="{{newsInfo.externalLinks}}" target="_blank" rel="noopener">{{newsInfo.externalLinks.length >
                35 ? newsInfo.externalLinks.slice(0,35)+'...' : newsInfo.externalLinks}}</a>
              </div>
              <div class="news_link_div side-left"
                *ngIf="newsInfo.externalLinks!= null  && newsInfo.externalLinks.substring(0,4) !='http'">
                <a class="news_link" href="http://{{newsInfo.externalLinks}}" target="_blank">{{newsInfo.externalLinks.length > 35 ? newsInfo.externalLinks.slice(0,35)+'...' :
                newsInfo.externalLinks}}</a>
              </div>
              <div class="news_link_div side-left" *ngIf="newsInfo.fileDownloadURL">
                <a class="other-file" (click)="downloadFile(newsInfo.fileDownloadURL)" id="downloadFile"
                  downloadAttachments-btn>Click here to download the file <i class="fa fa-download" aria-hidden="true"
                    style="font-size: 20px;margin-left: 5px;" (click)="downloadFile(newsInfo.fileDownloadURL)"></i></a>
              </div>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>



  <!-- large screen -->
  <div id="upcomingevents_web">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 upcoming_events_outerdiv">
          <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
          <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
            *ngFor="let events of upcomingEventsInfo; let i = index" (click)="openeventsDetails(events.eventId)">
            <div *ngIf="i <= 2">
              <div class="date_span">
                <div class="event_day">{{events.eventDay}}</div>
                <div class="event_monthname">{{events.eventMonth}}</div>
              </div>
              <div class="content_span_font">
                <span class="event_name_font_weight">{{events.eventName}}</span><br>
                <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                  </span>{{events.venue}}</span><br>
                <span>{{events.bpgName}}</span>
              </div>
              <div id="eventlist{{i}}{{i}}" class="icon-arrowleft-div" [ngClass]="{'hideDiv': i >= 1}">
                <i class="fa fa-caret-left arrow-left-i" aria-hidden="true"></i>
              </div>
            </div>

          </div>
          <a class="viewmoreevents_anchor" *ngIf="upcomingEventsInfo != null && upcomingEventsInfo.length>=3"
            (click)="viewMoreEvents()">View
            more events >></a>

        </div>
        <div class="col-md-6 upcoming_events_outerdiv evnt_detls_outerdiv">
          <h2 class="upcoming_events_margin eventname_clor" *ngIf="upcomingEventsInfo">{{eventName}}</h2>
          <p class="eventdetails_clor" *ngIf="upcomingEventsInfo">{{eventDetails1}}</p>

          <input type="hidden" class="form-control" name="eventId" [(ngModel)]="eventId">
          <a class="viewmoreeventsdeatils_anchor" (click)="viewMoreEventsDetails(eventId)"
            *ngIf="(upcomingEventsInfo != undefined && this.upcomingEventsInfo.length!=0)">View details >></a>
        </div>
      </div>
    </div>
  </div>


  <!-- small screen -->
  <div id="upcomingevents_mob" class="marginBottom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 upcoming_events_outerdiv"
          [ngClass]="{'hide-for-mobile': (upcomingEventsInfo != undefined && upcomingEventsInfo.length < 1)}">
          <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
          <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
            *ngFor="let events of upcomingEventsInfo; let i = index" (click)="openeventsDetails(events.eventId)">
            <div *ngIf="i <= 2">
              <div class="date_span">
                <div class="event_day">{{events.eventDay}}</div>
                <div class="event_monthname">{{events.eventMonth}}</div>

              </div>
              <div class="content_span_font">
                <span class="event_name_font_weight">{{events.eventName}}</span><br>
                <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                  </span>{{events.venue}}</span><br>
                <span>{{events.bpgName}}</span>
              </div>

            </div>
          </div>
          <a class="viewmoreevents_anchor" *ngIf="upcomingEventsInfo != null && upcomingEventsInfo.length>=3"
            (click)="viewMoreEvents()">View more events >></a>

        </div>
        <div class="col-md-12 upcoming_events_outerdiv evnt_detls_outerdiv">
          <h2 class="upcoming_events_margin eventname_clor" *ngIf="upcomingEventsInfo">{{eventName}}</h2>
          <p class="eventdetails_clor" id="event_description_div" *ngIf="upcomingEventsInfo">{{eventDetails1}}</p>

          <input type="hidden" class="form-control" name="eventId" [(ngModel)]="eventId">
          <a class="viewmoreeventsdeatils_anchor" (click)="viewMoreEventsDetails(eventId)"
            *ngIf="(upcomingEventsInfo != undefined && this.upcomingEventsInfo.length!=0)">View details >></a>
        </div>
      </div>
    </div>
  </div>
